import {InternalChatMessageEntity} from "@dropDesk/domain/entities/internal_chat/messages/internal_chat_message_entity";
import {generateUUIDV4} from "@dropDesk/utils/uuidv4/uuidv4";
import {getIdCompanyByLocalStorage} from "@dropDesk/utils/helpers/common";
import {MessageChatType, MessageStatus} from "@dropDesk/domain/entities/ticket/message/external/message_entity";
import {InternalChatEntity} from "@dropDesk/domain/entities/internal_chat/internal_chat_entity";

export const newInternalChatMessage = (idInternalChat: string): InternalChatMessageEntity => {
    return new InternalChatMessageEntity({
        id: generateUUIDV4(),
        idCompany: getIdCompanyByLocalStorage(),
        idInternalChat,
        internalChat: undefined,
        idExternal: undefined,
        type: MessageChatType.textMessage,
        senderId: '',
        deleted: false,
        isPrivate: false,
        fromMe: true,
        status: MessageStatus.PENDING,
        createdAtLocal: new Date().toISOString()
    });
}
